export const getRandomColor = () => "#" + Math.floor(Math.random()*16777215).toString(16);

export const getRandomLightColor = () => 'hsl('+Math.floor(Math.random()*361)+',50%,75%)';